// skeleton/app/src/app/confirm-password/confirm-password.component.ts

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { LogoutServive } from '../logout/logout.service';
import { MenuNavbarComponent } from '../shared/components/menu-navbar/menu-navbar.component';
import { AuthorizationService } from '../shared/services/authorization.service';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { MenubarService } from '../shared/services/menunavbar.services';
import { UserServiceService } from '../user/survey-main/service/user-service.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Constants } from '../shared/constants';
import { ForgotPassword } from '../shared/models/forgotpassword.model';
import forge from 'node-forge';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../shared/services/notifications.service';
import { StorageService } from '../shared/services/token-storage.service';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.scss'],
  standalone: false,
})
export class ConfirmPasswordComponent implements OnInit {
  UserLoggedIn: boolean = false;

  public resetPasswordForm: FormGroup;
  public successMessage: string;
  public errorMessage: string;
  public showSuccess: boolean;
  public showError: boolean;
  public resetpasswordscreeen: boolean = false;
  constant: Constants = new Constants();

  constructor(
    private _authService: BaseHttpService,
    private spinnerService: NgxSpinnerService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private router: Router,
    private logoutservice: LogoutServive,
    private baseHttpService: BaseHttpService,
    private userService: UserServiceService,
    private route: ActivatedRoute,
    private sessionHandlerService: GlobalsessionhandlerService,
    private menubarService: MenubarService,
    private globalsessionhandler: GlobalsessionhandlerService,
    private authorization: AuthorizationService,
    private menubar: MenuNavbarComponent,
    private storage: StorageService
  ) {}

  ngOnInit() {
    this.resetPasswordForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
    });

    this.menubarService.updatedDataSelection(false);
    this.sessionHandlerService.clearSession();
    this.authService.removeToken();
    this.logoutservice.changeMessage(false);

    this.logoutservice.changeMessage(this.UserLoggedIn);
    this.menubar.ngOnInit();
    this.router.navigate(['/', 'confirmPassword']);
  }

  public validateControl = (controlName: string) => {
    return (
      this.resetPasswordForm.controls[controlName].invalid &&
      this.resetPasswordForm.controls[controlName].touched
    );
  };

  public hasError = (controlName: string, errorName: string) => {
    return this.resetPasswordForm.controls[controlName].hasError(errorName);
  };

  public resetPassword = (resetPasswordFormValue) => {
    this.spinnerService.show();
    this.showError = this.showSuccess = false;

    let rsa = forge.pki.publicKeyFromPem(this.constant.publicKey);
    resetPasswordFormValue.email = window.btoa(
      rsa.encrypt(resetPasswordFormValue.email, 'RSA-OAEP', {
        md: forge.md.sha1.create(),
      })
    );

    const resettPass = { ...resetPasswordFormValue };

    const resetPassDto: ForgotPassword = {
      email: this.storage.get('LoggedInuserMailId'),
      clientURI: window.location.origin + this.constant.resetURL,
      password: resettPass.password,
    };

    this._authService.post(this.constant.oldPassword, resetPassDto).subscribe(
      async (result) => {
        if (result != null) {
          this.showSuccess = true;
          this.spinnerService.hide();
          window.location.href = result.value;
          this.notificationService.showSuccess('Please enter your new password.', '');
        } else {
          this.notificationService.showError(
            'Please enter correct  old Password',
            'Reset failed'
          );
        }
      },
      (err) => {
        this.showError = true;
        this.errorMessage = err.error;
        this.spinnerService.hide();
        this.resetPasswordForm.reset();
      }
    );
  };

  cancel() {
    this.router.navigate(['/', 'login']);
  }
}
